import { render } from "./NotFound.vue?vue&type=template&id=32d6e795&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-32d6e795"

export default script